export default __webpack_public_path__ + "static/media/brand.5fa61142.svg";